import React, { useEffect, useMemo, useState } from 'react';
import { Box, Breadcrumbs, Fab, IconButton, Link, Tooltip, Typography } from '@mui/material';
import { MdiIcon, Table } from '@components';
import { mdiMagnify, mdiPlus } from '@mdi/js';
import { useModal } from 'mui-modal-provider';
import { AddVendedorDialog } from './dialog';
const CrmVendedoresListView = ({ $state, CrmService }) => {
    const loadParams = () => {
        const sortBy = $state.params.sortBy;
        if (sortBy == undefined) {
            return [];
        }
        const o = [];
        sortBy.forEach(r => {
            const s = r.split(':');
            o.push({ id: s[0], desc: s[1] == 'DESC' });
        });
        return o;
    };
    const { showModal } = useModal();
    const [data, setData] = useState(); // dados dos Vendedores
    const [loading, setLoading] = useState(true);
    const [refetching, setRefetching] = useState(false);
    const [error, setError] = useState(false);
    const [filter, setFilter] = useState([]); // filtros a aplicar na tabela
    // exemplo -> [{ id: 'nome', value: 'Pedro', type: 'contains' }, { id: 'email', value: 'gmail', type: 'contains' }]
    const [sort, setSort] = useState(() => loadParams()); // ordenação da tabela
    // exemplo -> [{id: 'ultimoContacto', desc: false}]
    const [options, setOptions] = useState({
        filter: [], // exemplo -> [{name: 'nome', type: 'TEXT'}, {name: 'ultimoContacto', type: 'DATE', options: {format: 'YYYY-MM-DD'}}, ...]
        sort: [] // exemplo -> ['id', 'nome', 'ultimoContacto', 'contactoTelefonico', 'nif', 'email', 'morada', 'localidade']
    });
    const [pagination, setPagination] = useState({
        pageIndex: $state.params.page - 1 || 0,
        pageSize: $state.params.limit || 20
    });
    const initialTableState = useMemo(() => ({
        sort,
        filter
    }), [sort, filter]);
    const columns = useMemo(() => [
        {
            accessorKey: 'Funcionario.name',
            header: 'Nome',
            size: 100
        },
        {
            accessorKey: 'Funcionario.email',
            header: 'Email',
            size: 200
        },
        {
            accessorKey: 'Funcionario.telemovel',
            header: 'Telemóvel',
            size: 100
        }
    ], []);
    function stringToColor(string) {
        let hash = 0;
        let i;
        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = '#';
        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */
        return color;
    }
    function stringAvatar(name) {
        // Verifica se o nome é válido e tem pelo menos uma palavra
        const nameParts = name.split(' ');
        const firstInitial = nameParts[0] ? nameParts[0][0] : '';
        const secondInitial = nameParts[1] ? nameParts[1][0] : '';
        return {
            sx: {
                bgcolor: stringToColor(name)
            },
            children: `${firstInitial}${secondInitial}`
        };
    }
    // Filtragem dentro de cada coluna
    // Modo de filtro (igual a, contém, começa com... )
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    // ir para detalhes da pessoa (envia id da empresa)
    const onCellView = (cell) => {
        $state.go('app.crm.vendedores.details', { id: cell.id });
    };
    const initialFetch = async () => {
        if (loading) {
            // opt -> vai buscar os campos filtraveis
            const opt = await CrmService.optionsVendedores();
            setOptions(opt);
            setLoading(false);
        }
    };
    const fetchData = async () => {
        setError(false);
        try {
            let filters = {};
            filter.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sort.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            const aux = await CrmService.findAllVendedores({
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            $state.go($state.current.name, {
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filter).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            // Update URL
            setData(aux);
        }
        catch (e) {
            console.log(e);
            setError(true);
        }
        setRefetching(false);
    };
    const handleDialogData = async (value) => {
        try {
            await CrmService.createVendedor(value);
            setLoading(true);
            fetchData();
        }
        catch (error) {
            console.log('Erro ao adicionar Vendedor', error);
        }
        console.log(value);
    };
    useEffect(() => {
        initialFetch();
        if (!refetching) {
            setRefetching(true);
            fetchData();
        }
    }, [pagination, filter, sort]);
    return (<Box sx={{ mt: 2, pr: 1, pl: 1 }}>
      <Breadcrumbs aria-label='breadcrumb'>
        <Link underline='none' color='inherit'>
          CRM
        </Link>
        <Link underline='hover' color='text.primary' aria-current='page'>
          Vendedores
        </Link>
      </Breadcrumbs>

      <Typography variant='h4' sx={{ color: 'black', mt: 2 }}>
        Vendedores
      </Typography>
      <Box sx={{
            mt: 2,
            borderRadius: '15px', // Aplica o arredondamento na parte externa
            border: '1px solid #e0e0e0', // Adiciona uma borda leve
            overflow: 'hidden', // Garante que o conteúdo não extrapole o arredondamento
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)' // Adiciona uma leve sombra
        }}>
        <Table onDoubleClick={row => {
            onCellView(row);
        }} storageKey={$state.current.name} data={data} columns={columns} initial={initialTableState} isLoading={refetching} options={options} onPaginate={setPagination} onFilter={setFilter} onSort={setSort} actionItems={({ row }) => [
            <Tooltip title={'Ver detalhes'} placement='top' key={row.original.id}>
              <IconButton color='secondary' onClick={() => {
                    $state.go('app.crm.vendedores.details', { id: row.original.id });
                }}>
                <MdiIcon path={mdiMagnify} sx={{ color: '#1976D2' }}/>
              </IconButton>
            </Tooltip>
        ]}></Table>
      </Box>

      <Fab aria-label='add' color='error' sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1000
        }} onClick={() => showModal(AddVendedorDialog, {
            CrmService: CrmService,
            title: 'Adicionar Vendedor',
            onClose: (value) => {
                if (value) {
                    handleDialogData(value);
                }
            }
        })}>
        <MdiIcon path={mdiPlus} sx={{ color: '#ffffff' }}/>
      </Fab>
    </Box>);
};
export default CrmVendedoresListView;
